<template>
  <!--Update 23/05/2022 09:57:56  d:\projects\newProject\src\components\customers\testingreqList.vue-->
  <v-container fluid>
    <v-layout row wrap v-if="$store.getters.isAuthen" v-resize="onResize">
      <v-flex xs12>
        <v-card>
          <v-card-text class="hidden-sm-and-up mb-0 pb-0">
            <h5>{{nameList}}</h5>
              <v-btn help="step-mb-1-2" class="btn text mx-0" fab x-small color="primary" @click="itemList">
                <v-icon>loop</v-icon>
              </v-btn>
              <v-btn @click="itemAdd" color="cyan" dark bottom right fab fixed v-show="!dialogEdit">
                <v-icon>add</v-icon>
              </v-btn>
          </v-card-text>
          <!--  title & search  -->
          <v-card-title class="py-0 ma-0 mb-1">
            <h3 class="hidden-xs-only">{{nameList}}
              <v-btn help="step-mb-1-2" class="btn text mx-0" text x-small color="primary" @click="itemList">
                <v-icon>loop</v-icon>
              </v-btn>
            </h3>
            <v-spacer class="hidden-xs-only"></v-spacer>
            <v-btn @click="itemAdd" class="hidden-xs-only" color="cyan" dark bottom right fab fixed v-show="!dialogEdit">
                <v-icon>add</v-icon>
            </v-btn>
            <v-text-field
              xs12
              md6
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
              @keypress.enter="itemList"
              @click:append="itemList"
            ></v-text-field>
          </v-card-title>
          <!--  Table  -->
          <v-data-table
            ref="mainTable"
            :height="windowSize.tableHeight"
            fixed-header
            :hide-default-footer="pagination.hidePaging"
            :mobile-breakpoint="0"
            v-model="tableSelected"
            :headers="customHeaders"
            :footer-props="tableFooter"
            :items="items"
             item-key="ID"
            :options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            :single-select="tableSingleSelect"
            :show-select="tableShowSelect"
            :item-class="itemRowBackground"
           >
            <!--  Table Columns  -->

            <template v-slot:[`header.actions`]="props">
              <v-btn class="ml-1" @click="itemAdd" color="cyan" dark bottom fab x-small v-show="!dialogEdit" >
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn class="ml-1" @click="itemList" color="cyan" dark bottom fab x-small v-show="!dialogEdit" >
                <v-icon>loop</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.ID`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('ID:' +props.item.ID)"
                >
                  {{ props.item.ID }}
              </div>
            </template>
            <template v-slot:[`item.ReqOnlineNo`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('ReqOnlineNo:' +props.item.ReqOnlineNo)"
                >
                  {{ props.item.ReqOnlineNo }}
              </div>
            </template>
            <template v-slot:[`item.ReqNo`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('ReqNo:' +props.item.ReqNo)"
                >
                  {{ props.item.ReqNo }}
              </div>
            </template>
            <template v-slot:[`item.DateReceived`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('DateReceived:' +props.item.DateReceived)"
                >
                  {{ props.item.DateReceived }}
              </div>
            </template>
            <template v-slot:[`item.Name`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Name:' +props.item.Name)"
                >
                  {{ props.item.Name }}
              </div>
            </template>
            <template v-slot:[`item.Position`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Position:' +props.item.Position)"
                >
                  {{ props.item.Position }}
              </div>
            </template>
            <template v-slot:[`item.CompanyName`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('CompanyName:' +props.item.CompanyName)"
                >
                  {{ props.item.CompanyName }}
              </div>
            </template>
            <template v-slot:[`item.Address`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Address:' +props.item.Address)"
                >
                  {{ props.item.Address }}
              </div>
            </template>
            <template v-slot:[`item.Tel`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Tel:' +props.item.Tel)"
                >
                  {{ props.item.Tel }}
              </div>
            </template>
            <template v-slot:[`item.Fax`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Fax:' +props.item.Fax)"
                >
                  {{ props.item.Fax }}
              </div>
            </template>
            <template v-slot:[`item.Email`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Email:' +props.item.Email)"
                >
                  {{ props.item.Email }}
              </div>
            </template>
            <template v-slot:[`item.Rpt_Address_YN`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Rpt_Address_YN:' +props.item.Rpt_Address_YN)"
                >
                  {{ props.item.Rpt_Address_YN }}
              </div>
            </template>
            <template v-slot:[`item.Rpt_CompanyName`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Rpt_CompanyName:' +props.item.Rpt_CompanyName)"
                >
                  {{ props.item.Rpt_CompanyName }}
              </div>
            </template>
            <template v-slot:[`item.Rpt_Address`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Rpt_Address:' +props.item.Rpt_Address)"
                >
                  {{ props.item.Rpt_Address }}
              </div>
            </template>
            <template v-slot:[`item.Sample_condition`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Sample_condition:' +props.item.Sample_condition)"
                >
                  {{ props.item.Sample_condition }}
              </div>
            </template>
            <template v-slot:[`item.Sample_note`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Sample_note:' +props.item.Sample_note)"
                >
                  {{ props.item.Sample_note }}
              </div>
            </template>
            <template v-slot:[`item.Sample_Preservation`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Sample_Preservation:' +props.item.Sample_Preservation)"
                >
                  {{ props.item.Sample_Preservation }}
              </div>
            </template>
            <template v-slot:[`item.Sample_Preservation_Condition`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Sample_Preservation_Condition:' +props.item.Sample_Preservation_Condition)"
                >
                  {{ props.item.Sample_Preservation_Condition }}
              </div>
            </template>
            <template v-slot:[`item.Return_Sample`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Return_Sample:' +props.item.Return_Sample)"
                >
                  {{ props.item.Return_Sample }}
              </div>
            </template>
            <template v-slot:[`item.Report_TH`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Report_TH:' +props.item.Report_TH)"
                >
                  {{ props.item.Report_TH }}
              </div>
            </template>
            <template v-slot:[`item.Report_EN`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Report_EN:' +props.item.Report_EN)"
                >
                  {{ props.item.Report_EN }}
              </div>
            </template>
            <template v-slot:[`item.Report_Reception`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Report_Reception:' +props.item.Report_Reception)"
                >
                  {{ props.item.Report_Reception }}
              </div>
            </template>
            <template v-slot:[`item.NeedUncertainly`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('NeedUncertainly:' +props.item.NeedUncertainly)"
                >
                  {{ props.item.NeedUncertainly }}
              </div>
            </template>
            <template v-slot:[`item.Customer`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Customer:' +props.item.Customer)"
                >
                  {{ props.item.Customer }}
              </div>
            </template>
            <template v-slot:[`item.TAIStaff`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('TAIStaff:' +props.item.TAIStaff)"
                >
                  {{ props.item.TAIStaff }}
              </div>
            </template>
            <template v-slot:[`item.Review`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Review:' +props.item.Review)"
                >
                  {{ props.item.Review }}
              </div>
            </template>
            <template v-slot:[`item.Estimate_day`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Estimate_day:' +props.item.Estimate_day)"
                >
                  {{ props.item.Estimate_day }}
              </div>
            </template>
            <template v-slot:[`item.Estimate_date`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Estimate_date:' +props.item.Estimate_date)"
                >
                  {{ props.item.Estimate_date }}
              </div>
            </template>
            <template v-slot:[`item.Summary`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Summary:' +props.item.Summary)"
                >
                  {{ props.item.Summary }}
              </div>
            </template>
            <template v-slot:[`item.Case_condition`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('Case_condition:' +props.item.Case_condition)"
                >
                  {{ props.item.Case_condition }}
              </div>
            </template>
            <template v-slot:[`item.ReviewBy`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('ReviewBy:' +props.item.ReviewBy)"
                >
                  {{ props.item.ReviewBy }}
              </div>
            </template>
            <template v-slot:[`item.ReviewDate`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('ReviewDate:' +props.item.ReviewDate)"
                >
                  {{ props.item.ReviewDate }}
              </div>
            </template>
            <template v-slot:[`item.actions`]="props">
              <div @dblclick="dialogShow(props.item)"
                  nowrap
                  :class="props.header.class"
                  @click="showData('action')"
                >
                <v-btn class="ml-1" fab dark x-small color="blue" @click="dialogShow(props.item)">
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>                   
                <v-btn class="ml-1" fab dark x-small color="red" @click="itemDel(props.item)" v-permission="['admin']">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialogEdit"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-btn icon dark @click="dialogCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}{{nameList}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="itemSave" :disabled="!formValid  || loading">
              <v-icon>save</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <itemEdit ref="itemSelect" :action="actionList" :itemSelected="itemSelected" @update="itemUpdate" @valid="formValidEvent"></itemEdit>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import itemService from '@/store/api/services/customersService'
import itemEdit from '@/components/customers/testingreqEdit'

export default {
  name: 'testingReqList',
  components: {
      itemEdit
  },  
  props: {
    showGroup: {  // ใช้จัดกลุ่มแสดง column โดยถ้าตรงกับ headers ก็จะแสดง หรือ เป็นค่า 0 จะแสดงทุกกลุ่ม
      type: Number,
      default: function() {
        return 0
      }
    },
    parentItem: {  // ใช้รับค่า Code จากแม่
      type: Object,
      default: function() {
        return {}
      }
    },    
  },
  data() {
    return {
      actionList:'',
      title:'Edit',
      nameList:'รายการ',
      formValid: true,
      dialogEdit: false,
      toggle_process: 0,
      toggle_filter: [4],
      rootPath: process.env.VUE_APP_ROOT_PATH,
      serverName: process.env.VUE_APP_SERVER_NAME,
      apiPath: process.env.VUE_APP_API_PATH,
      search: '',
      error: null,
      totalItems: 0,
      items: [],
      windowSize: {
        x: 0,
        y: 0,
        tableHeight:0
      },
      tableFooter: {
          'items-per-page-options': [5,10, 15, 30, 50, 100,-1]
      },
      tableSelected: [],
      tableSingleSelect: true,
      tableShowSelect:false,
      itemSelected : {},
      itemOld : {},
      itemEmpty : { ID: '' ,ReqOnlineNo: '' ,ReqNo: '' ,DateReceived: '' ,Name: '' ,Position: '' ,CompanyName: '' ,Address: '' ,Tel: '' ,Fax: '' ,Email: '' ,Rpt_Address_YN: '' ,Rpt_CompanyName: '' ,Rpt_Address: '' ,Sample_condition: '' ,Sample_note: '' ,Sample_Preservation: '' ,Sample_Preservation_Condition: '' ,Return_Sample: '' ,Report_TH: '' ,Report_EN: '' ,Report_Reception: '' ,NeedUncertainly: '' ,Customer: '' ,TAIStaff: '' ,Review: '' ,Estimate_day: '' ,Estimate_date: '' ,Summary: '' ,Case_condition: '' ,ReviewBy: '' ,ReviewDate: '' },
      loading: true,
      pagination: {
        hidePaging:false,
        page: 1,
        itemsPerPage: 5,
        sortBy: ['ID'],
        sortDesc: [true],
        totalItems: 0,
        descending: true
      },
      headers: [
        {type: 'Action',  text: 'Action', value: 'actions', sortable: false, align: 'right', class: ['text-no-wrap'],showGroup:0},
        {type:'int', text: '_ID_', value: 'ID', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_ReqOnlineNo_', value: 'ReqOnlineNo', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_ReqNo_', value: 'ReqNo', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'datetime', text: '_DateReceived_', value: 'DateReceived', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Name_', value: 'Name', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Position_', value: 'Position', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_CompanyName_', value: 'CompanyName', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Address_', value: 'Address', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Tel_', value: 'Tel', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Fax_', value: 'Fax', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Email_', value: 'Email', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Rpt_Address_YN_', value: 'Rpt_Address_YN', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Rpt_CompanyName_', value: 'Rpt_CompanyName', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Rpt_Address_', value: 'Rpt_Address', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Sample_condition_', value: 'Sample_condition', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Sample_note_', value: 'Sample_note', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Sample_Preservation_', value: 'Sample_Preservation', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Sample_Preservation_Condition_', value: 'Sample_Preservation_Condition', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Return_Sample_', value: 'Return_Sample', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'int', text: '_Report_TH_', value: 'Report_TH', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'int', text: '_Report_EN_', value: 'Report_EN', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Report_Reception_', value: 'Report_Reception', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_NeedUncertainly_', value: 'NeedUncertainly', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Customer_', value: 'Customer', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_TAIStaff_', value: 'TAIStaff', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Review_', value: 'Review', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'int', text: '_Estimate_day_', value: 'Estimate_day', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'datetime', text: '_Estimate_date_', value: 'Estimate_date', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Summary_', value: 'Summary', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_Case_condition_', value: 'Case_condition', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'varchar', text: '_ReviewBy_', value: 'ReviewBy', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type:'datetime', text: '_ReviewDate_', value: 'ReviewDate', align: 'left', class: ['fill-height','text-no-wrap'], permission:[], showGroup:0},
        {type: 'Action',  text: 'Action', value: 'actions', sortable: false, align: 'right', class: ['text-no-wrap'],showGroup:0},
      ],
      //data()
    }
  },
  watch: {
    dialogEdit: {
      handler(value,oldValue) {
        console.log('testingReq watch dialog', value + ',' + oldValue )
        if (value) {
          document.documentElement.style.overflowY = "hidden"
        } else {
          document.documentElement.style.overflowY = "auto"
        }
      }
    },
    pagination: {
      handler() {
        console.log('testingReq watch page', this.pagination)
        this.itemList()
      },
      deep: true
    },
    search: {
      handler() {
        console.log('testingReq watch search', this.search)
      }
    },
    //watch()
  },  
  computed: {
    customHeaders() {
      return this.headers.filter(col =>{
        if(!Array.isArray(col.permission)){
          // ไม่ได้กำหนด permission
          return true && (col.showGroup === 0 || col.showGroup === this.showGroup)
        } 
        return this.$store.getters.checkPermission(col.permission) && (col.showGroup === 0 || col.showGroup === this.showGroup)
      })
    },    
    allPerson: function() {
      if (localStorage.getItem('EmpAll') !== '') {
        return JSON.parse(localStorage.getItem('EmpAll'))
      }
      localStorage.setItem(
        'EmpAll',
        JSON.stringify(this.$store.state.users.empAll)
      )
      return this.$store.state.users.empAll
    },
    //computed()
  },
  mounted() {
    if(!this.$store.getters.isAuthen) {
         this.$router.push('/signin/' + '?redirect=' + this.$route.path)
    }
    //mounted()
  },
  methods: {
    onResize () {
      let top = 0
      let el = this.$refs.mainTable.$el
      if (el) {
        top = 0
        while(el.offsetTop !== 0 ){
          console.log('onResize el', el)
          top += el.offsetTop
          el = el.offsetParent
        }
      }
      let footerH = document.querySelector('.v-data-footer').offsetHeight + document.querySelector('.v-card__title').offsetHeight
      let appToolbarH = 25
      this.windowSize = { x: window.innerWidth, 
                          y: window.innerHeight,
                          tableHeight:(window.innerHeight - top - appToolbarH - footerH)
                        }
                        console.log('onResize', top)
    },
    itemRowBackground: function(item) {
    //แทนเงื่อนไข ที่ (false) เช่น (item.status === 'cancel'
        return (false)
        ? 'cancalRow text-decoration-line-through'
        : 'normalRow'
    },
    checkPermission(permissionArray) {
      return this.$store.getters.checkPermission(permissionArray)
    },
    formValidEvent(valid) {
      this.formValid =valid
    },
    dialogShow(item) {
      console.log('testingReq dialogShow', item)
      this.itemSelected = item
      this.itemOld = Object.assign({},this.itemSelected)
      this.actionList = 'edit'
      this.title = 'Edit '
      this.dialogEdit = true
    },
    dialogCancel() {
      console.log('testingReq dialogCancel')
      this.itemRollback()
      this.dialogEdit = false
    },
    async itemSave(){
      console.log('testingReq itemSave')
      if(!this.dialogEdit) return
      this.loading = true
      if (await this.$refs.itemSelect.Save()) {
        console.log('{{itemName}} itemSave return true')
        this.itemOld = Object.assign({},this.itemSelected)
        this.dialogEdit = false
      } else {
        console.log('testingReq itemSave return false')
      }
      this.loading = false
    },
    async itemDel(item) {
      if (confirm("Are you sure you want to delete?" + 
                    "\n_ID_ : " + item.ID)) {
        this.loading = true
        console.log('testingReq Delete', item)
        let response = await itemService.testingReqDelete(item)
        console.log('testingReq Delete response',response)
        if (response.data.error === '') {
          console.log('testingReq Delete return true')
          this.items = this.items.filter(x => {
            if (!(x.ID  === item.ID)) {
              return true
            }
            return false
          })
          this.loading = false
        } else {
          console.log('testingReq Delete return false')
          alert('Delete Error')
        }
      }
    },
    showData(item){
      console.log('testingReq showData', item)
    },
    itemAdd(){
      console.log('testingReq itemAdd')
      this.itemOld = this.itemEmpty
      this.itemSelected = Object.assign({},this.itemOld)

      // init Add Item
      // this.itemSelected.ID = 'default Value'

      this.items.unshift(this.itemSelected)
      this.totalItems++
      this.actionList = 'add'
      this.title = 'New '
      this.dialogEdit = true
    },
    itemUpdate(item){
      console.log('testingReq itemUpdate', item)
      for (let prop in item){
        this.itemSelected[prop] = item[prop]
      }
      if(this.totalItems === 0){
        this.totalItems = 1
      }
    },
    itemRollback(){
      console.log('testingReq itemRollback', this.itemOld)
      if (this.actionList === 'add'){ // this.itemEmpty
        this.items.shift()
      } 
      if (this.actionList === 'edit'){ // this.itemEmpty
            for (let prop in this.itemOld){
            this.itemSelected[prop] = this.itemOld[prop]
          }
          // this.itemSelected = Object.assign({},this.itemOld)
      }
      this.actionList = 'roll back'
    },    
    async itemList() {
      this.loading = true
      console.log('quotation this.$route.params', this.$route.params)
      try {
        let multiSort = this.pagination.sortBy.map((item,index)=>{
            console.log(item,index)
            if (this.pagination.sortDesc[index]) {
                return item + ' desc'
            }else{
                return item
            }
        })
        let payload = {
          pageNo: this.pagination.page,
          rowsPerPage: this.pagination.itemsPerPage,
          sortBy: multiSort.toString(),
          descending: this.pagination.sortDesc[0],
          search: this.search,
          OwnerEmpCode: this.$store.state.users.main.empCode,
          filter: this.toggle_filter,
          process: this.toggle_process
        }
        const response = await itemService.testingreqListByParam(payload)
        this.loading = false
        this.items = response.data.data
        if (!this.items) {
          this.items = []
          this.itemSelected = {}
          // this.totalItems = 1
        } else {
          this.itemSelected = this.items[0]
          this.totalItems = response.data.totalRecords
        }
        // this.$store.commit('setLoadedbookIns', this.items)
        // console.log('bookIns1111', this.$store.state.taibook.bookIns)
        // this.$store.state.isAuthen = true
        // console.log('isAuthen', this.$store.state.isAuthen)
        return response.data
      } catch (e) {
        // console.log('error', e.response.status)
        itemService.errorHandel(e.response)
        this.loading = false
      }
    },
    //methods()
  }
}
</script>
<style scoped>
  /* fix dialog header */
  .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }
</style>
<style>
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>td {
    font-size: .75rem;
    height: 38px;
}
.cancalRow:hover {
  background-color: #fdd !important;
  color: #f00 !important;
}

.cancalRow {
  background-color: rgba(255, 0, 0, 0.1);
  color: #f00 !important;
}

.normalRow {
}
</style>
<style lang="scss" scoped>
 ::v-deep table > tbody > tr , ::v-deep table > thead > tr{
  background: white;
}
::v-deep table>tbody>tr>td:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: -250px;
  z-index: 1;
  background: inherit;
}

::v-deep table>thead>tr>th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: -250px;
  z-index: 3 !important;
  background: inherit;
}

::v-deep table>thead>tr>th:nth-child(1) {
  z-index: 3 !important;
}

::v-deep table>tbody>tr>td:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0px;
  z-index: 1;
  background: inherit;
}

::v-deep table>thead>tr>th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0px;
  z-index: 3 !important;
  background: inherit;
}

::v-deep table>thead>tr>th:nth-child(2) {
  z-index: 3 !important;
}
</style>
